// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u5-2";
export var chatLink = "_u5-0";
export var chatText = "_u5-1";